// Animations are skipped when the user's system asks for reduced motion, or when the
// page is opened with ?static (handy for screenshots and automated checks).
export const ANIMATE =
  typeof window === "undefined"
    ? false
    : !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
      !new URLSearchParams(window.location.search).has("static");
